<template>
  <div class="white-bg padding padding-top-lg">
    <div class="flex justify-center margin-bottom">
      <div style="width: 40%;">
        <el-input
          placeholder="请输入商品名称，会员名称，订单编号或者会员手机号"
          v-model="businessCenterInfo.searchValue"
          @keyup.enter.native="_doSearch()">
        </el-input>
      </div>
      <div class="margin-left-xs">
        <el-button type="primary" @click="_doSearch()">
          {{ $t('businessCenter.search') }}
        </el-button>
      </div>
    </div>
    <div class="vc-line-primary"></div>

    <div class="margin-top-sm">
      <el-tabs v-model="businessCenterInfo._currentTab" @tab-click="changeTab">
        <el-tab-pane 
          label="会员"
          name="businessDetailUser">
          <span slot="label">会员({{businessCenterInfo.shopVipUserDtos.length}})</span>
          <business-detail-user v-if="businessCenterInfo._currentTab == 'businessDetailUser'"></business-detail-user>
        </el-tab-pane>
        <el-tab-pane 
          label="商品"
          name="businessDetailGoods">
          <span slot="label">商品({{businessCenterInfo.productDtos.length}})</span>
          <business-detail-goods v-if="businessCenterInfo._currentTab == 'businessDetailGoods'"></business-detail-goods>
        </el-tab-pane>
        <el-tab-pane 
          label="订单"
          name="businessDetailOrder">
          <span slot="label">订单({{businessCenterInfo.storeOrderCartDtos.length}})</span>
          <business-detail-order v-if="businessCenterInfo._currentTab == 'businessDetailOrder'"></business-detail-order>
        </el-tab-pane>
        <el-tab-pane 
          label="退货订单"
          name="businessDetailRefund">
          <span slot="label">退货订单({{businessCenterInfo.storeOrderCartReturnDtos.length}})</span>
          <business-detail-refund v-if="businessCenterInfo._currentTab == 'businessDetailRefund'"></business-detail-refund>
        </el-tab-pane>
        <el-tab-pane 
          label="拼团商品"
          name="businessDetailGroup">
          <span slot="label">拼团商品({{businessCenterInfo.productGroupDtos.length}})</span>
          <business-detail-group v-if="businessCenterInfo._currentTab == 'businessDetailGroup'"></business-detail-group>
        </el-tab-pane>
        <el-tab-pane 
          label="拼团订单"
          name="businessDetailGroupOrder">
          <span slot="label">拼团订单({{businessCenterInfo.productGroupOrderDtos.length}})</span>
          <business-detail-group-order v-if="businessCenterInfo._currentTab == 'businessDetailGroupOrder'"></business-detail-group-order>
        </el-tab-pane>
        <el-tab-pane 
          label="秒杀商品"
          name="businessDetailSeckill">
          <span slot="label">秒杀商品({{businessCenterInfo.productSeckillDtos.length}})</span>
          <business-detail-seckill v-if="businessCenterInfo._currentTab == 'businessDetailSeckill'"></business-detail-seckill>
        </el-tab-pane>
        <el-tab-pane 
          label="秒杀订单"
          name="businessDetailSeckillOrder">
          <span slot="label">秒杀订单({{businessCenterInfo.productSeckillOrderDtos.length}})</span>
          <business-detail-seckill-order v-if="businessCenterInfo._currentTab == 'businessDetailSeckillOrder'"></business-detail-seckill-order>
        </el-tab-pane>
        <el-tab-pane 
          label="家政服务"
          name="businessDetailService">
          <span slot="label">家政服务({{businessCenterInfo.housekeepingServDtos.length}})</span>
          <business-detail-service v-if="businessCenterInfo._currentTab == 'businessDetailService'"></business-detail-service>
        </el-tab-pane>
        <el-tab-pane 
          label="家政物品"
          name="businessDetailResource">
          <span slot="label">家政物品({{businessCenterInfo.housekeepingResourceDtos.length}})</span>
          <business-detail-resource v-if="businessCenterInfo._currentTab == 'businessDetailResource'"></business-detail-resource>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import { getBusinessQuery } from '@/api/order/businessCenterApi'
import { getShopId } from '@/api/shop/shopApi'
import BusinessDetailUser from '@/components/user/businessDetailUser'
import BusinessDetailGoods from '@/components/order/businessDetailGoods'
import BusinessDetailOrder from '@/components/order/businessDetailOrder'
import BusinessDetailRefund from '@/components/order/businessDetailRefund'
import BusinessDetailGroup from '@/components/order/businessDetailGroup'
import BusinessDetailGroupOrder from '@/components/order/businessDetailGroupOrder'
import BusinessDetailSeckill from '@/components/order/businessDetailSeckill'
import BusinessDetailSeckillOrder from '@/components/order/businessDetailSeckillOrder'
import BusinessDetailService from '@/components/order/businessDetailService'
import BusinessDetailResource from '@/components/order/businessDetailResource'

export default {
  components: {
    BusinessDetailUser,
    BusinessDetailGoods,
    BusinessDetailOrder,
    BusinessDetailRefund,
    BusinessDetailGroup,
    BusinessDetailGroupOrder,
    BusinessDetailSeckill,
    BusinessDetailSeckillOrder,
    BusinessDetailService,
    BusinessDetailResource
  },
  data() {
    return {
      businessCenterInfo: {
        searchValue: '',
        shopVipUserDtos: [],
        productDtos: [],
        storeOrderCartDtos: [],
        storeOrderCartReturnDtos: [],
        productGroupDtos: [],
        productGroupOrderDtos: [],
        productSeckillDtos: [],
        productSeckillOrderDtos: [],
        housekeepingServDtos: [],
        housekeepingResourceDtos: [],
        _currentTab: 'businessDetailUser',
      }
    }
  },
  methods: {
    async _doSearch() {
      let shopId = await getShopId();
      getBusinessQuery({
        searchValue: this.businessCenterInfo.searchValue,
        shopId: shopId
      }).then(res => {
        this.businessCenterInfo = { ...this.businessCenterInfo, ...res.data }
        this.selectHasDataTab()
      })
    },
    selectHasDataTab() {
      const info = this.businessCenterInfo
      const tabs = [
        { key: 'shopVipUserDtos', name: 'businessDetailUser' },
        { key: 'productDtos', name: 'businessDetailGoods' },
        { key: 'storeOrderCartDtos', name: 'businessDetailOrder' },
        { key: 'storeOrderCartReturnDtos', name: 'businessDetailRefund' },
        { key: 'productGroupDtos', name: 'businessDetailGroup' },
        { key: 'productGroupOrderDtos', name: 'businessDetailGroupOrder' },
        { key: 'productSeckillDtos', name: 'businessDetailSeckill' },
        { key: 'productSeckillOrderDtos', name: 'businessDetailSeckillOrder' },
        { key: 'housekeepingServDtos', name: 'businessDetailService' },
        { key: 'housekeepingResourceDtos', name: 'businessDetailResource' }
      ]

      for (const tab of tabs) {
        if (info[tab.key] && info[tab.key].length > 0) {
          this.changeTab(tab.name)
          return
        }
      }
    },
    changeTab(tab) {
      this.businessCenterInfo._currentTab = tab
      this.$nextTick(() => {
        this.$emit('switch', this.businessCenterInfo)
      })
    }
  }
}
</script>

<style scoped>
.white-bg {
  background-color: #fff;
}
.padding {
  padding: 15px;
}
.padding-top-lg {
  padding-top: 20px;
}
.margin-bottom {
  margin-bottom: 15px;
}
.margin-left-xs {
  margin-left: 10px;
}
.margin-top-sm {
  margin-top: 10px;
}
.flex {
  display: flex;
}
.justify-center {
  justify-content: center;
}
.vc-line-primary {
  height: 1px;
  background-color: #ebeef5;
  margin: 15px 0;
}
</style>